const popstateHandlers = new Map<string, () => void>();

export const modalHide = (identifier: string, fromPopstate = false) => {
  const className = `${identifier}-modal`;
  const modal = document.querySelector(`.${className}`);
  if (modal) {
    modal.classList.add(`hidden`);
    modal.classList.remove(`block`);
    document.body.style.overflow = ``;
    document.documentElement.style.overflow = ``;
  } else {
    console.warn(`Unable to hide modal '${className}', not found`);
  }

  const handler = popstateHandlers.get(identifier);
  if (handler) {
    window.removeEventListener(`popstate`, handler);
    popstateHandlers.delete(identifier);
  }

  if (!fromPopstate && history.state?.modal === identifier) {
    history.back();
  }
};

export const modalShow = (identifier: string) => {
  const className = `${identifier}-modal`;
  const modal = document.querySelector(`.${className}`);
  if (modal) {
    modal.classList.add(`block`);
    modal.classList.remove(`hidden`);
    document.body.style.overflow = `hidden`;
    document.documentElement.style.overflow = `hidden`;
  } else {
    console.warn(`Unable to show modal '${identifier}', not found`);
    return;
  }

  history.pushState({ modal: identifier, }, ``);

  const handler = () => {
    modalHide(identifier, true);
  };
  popstateHandlers.set(identifier, handler);
  window.addEventListener(`popstate`, handler, { once: true, });
};
